export default __webpack_public_path__ + "static/desktop-megamenu-cropped-ff51c508ec9d8e0d9c1ed0d3aef7d0a3.svg";